import { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Spin,
} from "antd";
import { GetEnglishOrArabic } from "../";

import { LoadingOutlined } from "@ant-design/icons";
import {
  addProductToCart,
  editProductFromCart,
  updatePOSBranchProduct,
  updateUsedComponents,
} from "../../../store/actions";
import instance from "../../../store/actions/instance";
import { setDeliveryChargePOS } from "../../../store/actions/pos";
import { updateProduct } from "../../../store/actions/products";
import {
  getProductInventory,
  hasMissingRequiredExtraFields,
  isEmpty,
  preciseNumber,
} from "../../../store/reducers/pos";

import {
  isApplicableCategeoryPromo,
  isNotExcludedProuduct,
} from "../DiscountModal/helpers";
import ProductBookables from "./ProductBookables";
import ProductDescription from "./ProductDescription";
import ProductExtraFields from "./ProductExtraFields";
import ProductOptions from "./ProductOptions";
import OptionGroup from "./ProductOptions/OptionGroup";
import ProductResources from "./ProductResources";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function CalculateOptionsPrice(options) {
  let sum = 0;
  let selected_option = {};

  for (let key of Object.keys(options)) {
    selected_option = options[key].selectedOptions;

    for (let selected_key of Object.keys(selected_option)) {
      sum +=
        selected_option[selected_key].quantity *
        selected_option[selected_key].price;
    }
  }
  return sum;
}

class ProductModal extends Component {
  getInitialQuantity = () => {
    const product = this.props.originalProduct;
    const EditedProduct = this.props.EditedProduct;
    const { usedComponents } = this.props;
    if (EditedProduct && !EditedProduct.hasError) {
      return EditedProduct.quantity;
    }
    if (["stocked", "composite"].includes(product.type_of_product)) {
      const productInventory = getProductInventory(product, usedComponents);
      if (product.increments > productInventory) {
        return 0;
      }
    }

    return product.increments;
  };

  getUsedComponents = () => {
    const { EditedProduct, originalProduct } = this.props;
    if (!EditedProduct) {
      const usedComponents = {};
      if (originalProduct.type_of_product === "composite") {
        Object.entries(originalProduct.components_dict || {}).forEach(
          ([productId, { required_amount }]) => {
            usedComponents[productId] =
              (usedComponents[productId] || 0) + required_amount;
          },
        );
      } else if (originalProduct.type_of_product === "stocked") {
        usedComponents[originalProduct.id] =
          usedComponents[originalProduct.id] || 1;
      }
      return usedComponents;
    }

    return { ...EditedProduct?.usedComponents } || {};
  };

  getProductUnitPrice = (product, bookingSlotId) => {
    let unitPrice = product.price;
    if (
      bookingSlotId &&
      bookingSlotId !== -1 &&
      product.type_of_product == "bookable" &&
      product.booking_slots?.length > 0
    ) {
      const slot = product.booking_slots.find((s) => s.id === bookingSlotId);

      if (slot && slot?.price != undefined) {
        unitPrice = slot.price;
      }
    }
    return unitPrice;
  };
  getOptions = () => {
    return this.props.EditedProduct
      ? JSON.parse(JSON.stringify(this.props.EditedProduct.options || {}))
      : {};
  };

  state = {
    quantity: this.getInitialQuantity(),
    usedComponents: this.getUsedComponents(),
    options: this.getOptions(),
    extraFields: this.props.EditedProduct?.extraFields || {},
    bookingSlot: this.props.EditedProduct?.booking_slot || null,
    ignoreInventory: this.props.EditedProduct?.ignoreInventory || false,

    specialRemarks: this.props.EditedProduct?.specialRemarks || "",

    has_resources: this.props.EditedProduct?.has_resources || true,
    has_resource_slots: this.props.EditedProduct?.has_resource_slots || true,
    resource: this.props.EditedProduct?.resource || null,
    resourceSlot: this.props.EditedProduct?.resourceSlot || null,
    resourceError: this.props.EditedProduct?.resourceError || false,

    descriptionModalVisible: false,

    filename: this.props.specialRemarksFileName || undefined,

    conditionalStack: [],
  };
  getCurrentConditional() {
    const { conditionalStack } = this.state;
    return conditionalStack[conditionalStack.length - 1] || null;
  }
  fetchProductDetails = async (id) => {
    const { t, settings, branch } = this.props;
    try {
      const res = await instance.get(
        `/get_product_details/${id}/${branch ? branch + "/" : ""}`,
      );
      if (settings.is_branch_based_ordering) {
        this.props.updatePOSBranchProduct(res.data.product);
      } else {
        this.props.updateProduct(res.data.product);
      }
    } catch (err) {
      if (err.response.status == 403) message.error(t("SomethingWentWrong"));
    }
  };

  componentDidMount = () => {
    const { originalProduct } = this.props;

    if (!originalProduct.did_load) {
      this.fetchProductDetails(originalProduct.id);
    }
  };

  setNewQuantity = (newQuantity) => {
    this.setState({ quantity: newQuantity });
  };
  getMaximumProductInventoryFromModifiers = (deltaQuantity) => {
    let productMaxInventory = Infinity;
    const { options, quantity } = this.state;
    const { usedComponents, EditedProduct } = this.props;
    const totalUsedComponents = { ...usedComponents };

    Object.entries(EditedProduct?.usedComponents || {}).forEach(
      ([optionId, optionQuantity]) => {
        const newOptionId = optionId.toString().replace("Q", "");
        totalUsedComponents[newOptionId] =
          (totalUsedComponents[newOptionId] || 0) -
          optionQuantity *
            ((optionId.toString().includes("Q") && 1) ||
              EditedProduct?.quantity);
      },
    );

    Object.entries(this.state.usedComponents).forEach(
      ([optionId, optionQuantity]) => {
        const newOptionId = optionId.toString().replace("Q", "");
        totalUsedComponents[newOptionId] =
          (totalUsedComponents[newOptionId] || 0) +
          optionQuantity *
            ((optionId.toString().includes("Q") && 1) || quantity);
      },
    );

    Object.values(options).forEach((option) => {
      Object.values(option.selectedOptions).forEach((choice) => {
        if (
          choice.maxInventory !== null &&
          choice.related_product &&
          !option.quantityExclusive
        ) {
          let choiceInventory = getProductInventory(
            choice.related_product,
            totalUsedComponents,
          );

          const maxExtraAmount =
            choiceInventory /
              (choice.quantity +
                this.getQuantityUsedPerProductIncrease(
                  choice.related_product,
                )) +
            quantity;

          productMaxInventory = Math.min(productMaxInventory, maxExtraAmount);
          if (choice.related_product.type_of_product === "stocked") {
            totalUsedComponents[choice.related_product.id] =
              (totalUsedComponents[choice.related_product.id] || 0) +
              quantity * choice.quantity;
          } else if (choice.related_product.type_of_product === "composite") {
            Object.entries(choice.related_product.components).forEach(
              ([productId, product]) => {
                totalUsedComponents[productId] =
                  (totalUsedComponents[productId] || 0) +
                  quantity * choice.quantity * product.required_amount;
              },
            );
          }
        }
      });
    });

    return productMaxInventory;
  };
  getQuantityUsedPerProductIncrease = (modifier) => {
    const { originalProduct } = this.props;
    const componentsToBeUsed = {};
    if (originalProduct.type_of_product === "composite") {
      Object.entries(originalProduct.components_dict || {}).forEach(
        ([productId, { required_amount }]) => {
          componentsToBeUsed[productId] =
            (componentsToBeUsed[productId] || 0) + required_amount;
        },
      );
    } else if (originalProduct.type_of_product === "stocked") {
      componentsToBeUsed[originalProduct.id] =
        componentsToBeUsed[originalProduct.id] || 0;
    }
    return (
      modifier.inventory_on_hand -
      getProductInventory(modifier, componentsToBeUsed)
    );
  };
  hasEnoughInventory = (newQuantity, originalProduct) => {
    let type_of_product = originalProduct.type_of_product;
    const productUsedComponents = this.state.usedComponents;
    const { usedComponents } = this.props;
    const editedProductQuantity =
      (!this.props.EditedProduct?.ignoreInventory &&
        this.props.EditedProduct?.EditedProduct?.booking_slot ==
          this.state.bookingSlot &&
        this.props.EditedProduct?.quantity) ||
      0;
    const totalUsedComponents = { ...usedComponents };
    Object.entries(productUsedComponents).forEach(
      ([optionId, optionQuantity]) => {
        const newOptionId = optionId.toString().replace("Q", "");
        totalUsedComponents[newOptionId] =
          (totalUsedComponents[newOptionId] || 0) +
          optionQuantity *
            ((optionId.toString().includes("Q") && 1) || this.state.quantity);
      },
    );

    if (
      (["stocked", "composite"].includes(type_of_product) &&
        (this.state.ignoreInventory ||
          newQuantity - this.state.quantity <=
            getProductInventory(originalProduct, totalUsedComponents) +
              editedProductQuantity)) ||
      type_of_product === "produced" ||
      (type_of_product === "bookable" &&
        !["Out", -1].includes(this.state.bookingSlot) &&
        (this.state.ignoreInventory ||
          newQuantity <=
            originalProduct.booking_slots.find(
              (slot) => slot.id === this.state.bookingSlot,
            ).inventory +
              editedProductQuantity))
    ) {
      return true;
    }
    return false;
  };

  getMaxInventory = (originalProduct, IgnoreOverrideInventory = false) => {
    const { usedComponents, EditedProduct } = this.props;
    switch (originalProduct.type_of_product) {
      case "composite":
      case "stocked":
        return this.state.ignoreInventory && !IgnoreOverrideInventory
          ? Infinity
          : getProductInventory(originalProduct, usedComponents) +
              (EditedProduct?.quantity || 0);
      case "bookable":
        const bookingSlot = originalProduct.booking_slots.find(
          (slot) => slot.id === this.state.bookingSlot,
        );
        return bookingSlot
          ? this.state.ignoreInventory && !IgnoreOverrideInventory
            ? Infinity
            : bookingSlot.inventory +
              ((!this.state.ignoreInventory &&
                EditedProduct?.booking_slot == this.state.bookingSlot &&
                EditedProduct?.quantity) ||
                0)
          : 0;
      default:
        return Infinity;
    }
  };

  getBookingSlotDetails = () => {
    const { originalProduct } = this.props;
    const { bookingSlot } = this.state;
    if (bookingSlot) {
      return {
        ...originalProduct.booking_slots.find(
          (slot) => slot.id === bookingSlot,
        ),
      };
    }
    return null;
  };

  addProductToCart = (promoItems) => {
    const { product, addProductToCart, onClose, originalProduct, t, products } =
      this.props;
    const {
      quantity,
      options,
      bookingSlot,
      ignoreInventory,
      specialRemarks,
      extraFields,
    } = this.state;
    let bookingSlotDetails = null;
    if (originalProduct.type_of_product === "service") {
      if (
        !this.state.resource ||
        !this.state.resourceSlot ||
        this.state.resourceSlot == -1
      ) {
        this.setState({
          resourceError: true,
        });
        return;
      }
    }

    let quantityLeft = quantity;
    let quantityToBeAdded = quantityLeft;
    for (let i = 0; i < promoItems.length; i++) {
      quantityToBeAdded = quantityLeft;
      if (promoItems[i].quantity < quantityLeft) {
        quantityToBeAdded = promoItems[i].quantity;
      }
      addProductToCart({
        product,
        quantity: quantityToBeAdded,
        ...this.getTotalPrice(
          this.getProductUnitPrice(originalProduct, bookingSlot),
          1,
          options,
          extraFields,
        ),
        options: options,
        booking_slot: bookingSlot,
        bookingSlotDetails:
          (bookingSlot && this.getBookingSlotDetails()) || null,
        ignoreInventory: ignoreInventory,
        specialRemarks: specialRemarks,
        resource: this.state.resource,
        resourceSlot: this.state.resourceSlot,
        extraFields: extraFields,
        usedComponents: this.state.usedComponents,
        promo: promoItems[i].promo,
        discount: promoItems[i].id,
        discountType:
          (promoItems[i].categories && "category_free") || "products",
        forcedPrice: 0,
      });
      quantityLeft -= quantityToBeAdded;
      if (quantityLeft <= 0) break;
    }

    if (quantityLeft > 0) {
      addProductToCart({
        product,
        quantity: quantityLeft,
        ...this.getTotalPrice(
          this.getProductUnitPrice(originalProduct, bookingSlot),
          1,
          options,
          extraFields,
        ),
        options: options,
        booking_slot: bookingSlot,
        bookingSlotDetails:
          (bookingSlot && this.getBookingSlotDetails()) || null,
        ignoreInventory: ignoreInventory,
        specialRemarks: specialRemarks,
        resource: this.state.resource,
        resourceSlot: this.state.resourceSlot,
        extraFields: extraFields,
        usedComponents: this.state.usedComponents,
      });
    }
    const allCharged = this.props.pos.cart?.every(
      (product) => !product["chargeDelivery"],
    );
    this.props.setDeliveryChargePOS({
      deliveryCharge:
        this.props.pos.cart.length && allCharged
          ? 0
          : this.props.pos.deliveryChargeBackup,
      fromPage: "products",
    });
    let usedComponents = { ...this.props.usedComponents };

    let shouldUpdateComponents = false;

    if (!ignoreInventory) {
      Object.entries(this.state.usedComponents).forEach(
        ([optionId, optionQuantity]) => {
          shouldUpdateComponents = true;
          const newOptionId = optionId.toString().replace("Q", "");
          usedComponents[newOptionId] =
            (usedComponents[newOptionId] || 0) +
            optionQuantity *
              ((optionId.toString().includes("Q") && 1) || quantity);
        },
      );
      let type_of_product = originalProduct.type_of_product;
      if (type_of_product === "bookable") {
        originalProduct.booking_slots.find(
          (slot) => slot.id === this.state.bookingSlot,
        ).inventory -= quantity;
      }
      if (shouldUpdateComponents) {
        this.props.updateUsedComponents(usedComponents);
      }
    }
    message.success(t("Product Added to Cart"));

    onClose();
  };
  returnInventory = (originalProduct, item, quantityDifference) => {
    const { EditedProduct } = this.props;
    const { usedComponents, quantity } = this.state;
    let newUsedComponents = { ...this.props.usedComponents };
    const type_of_product = originalProduct.type_of_product;
    if (type_of_product === "bookable") {
      const bookingSlot = originalProduct.booking_slots.find(
        (bs) => bs.id === item.booking_slot,
      );
      if (bookingSlot) {
        bookingSlot.inventory += quantityDifference;
      }
    }

    Object.entries(EditedProduct?.usedComponents || {}).forEach(
      ([optionId, optionQuantity]) => {
        const newOptionId = optionId.toString().replace("Q", "");
        newUsedComponents[newOptionId] =
          (newUsedComponents[newOptionId] || 0) -
          optionQuantity *
            ((optionId.toString().includes("Q") && 1) ||
              EditedProduct.quantity);
      },
    );

    Object.entries(usedComponents).forEach(([optionId, optionQuantity]) => {
      const newOptionId = optionId.toString().replace("Q", "");
      newUsedComponents[newOptionId] =
        (newUsedComponents[newOptionId] || 0) +
        optionQuantity * ((optionId.toString().includes("Q") && 1) || quantity);
    });

    this.props.updateUsedComponents(newUsedComponents);
  };

  EditProduct = () => {
    const {
      product,
      editProductFromCart,
      onClose,
      originalProduct,
      t,
      EditedProduct,
    } = this.props;
    const {
      quantity,
      options,
      bookingSlot,
      ignoreInventory,
      specialRemarks,
      extraFields: extraFields,
      usedComponents,
    } = this.state;

    if (originalProduct.type_of_product === "service") {
      if (
        !this.state.resource ||
        !this.state.resourceSlot ||
        this.state.resourceSlot == -1
      ) {
        this.setState({
          resourceError: true,
        });
        return;
      }
    }

    if (
      EditedProduct.booking_slot != bookingSlot ||
      (!EditedProduct.ignoreInventory && ignoreInventory)
    ) {
      this.returnInventory(
        originalProduct,
        EditedProduct,
        EditedProduct.quantity,
      );
    }
    editProductFromCart({
      product,
      quantity,
      ...this.getTotalPrice(
        this.getProductUnitPrice(originalProduct, bookingSlot),
        1,
        options,
        extraFields,
      ),
      options: options,
      booking_slot: bookingSlot,
      bookingSlotDetails: bookingSlot && this.getBookingSlotDetails(),
      ignoreInventory: ignoreInventory,
      specialRemarks: specialRemarks,
      resource: this.state.resource,
      resourceSlot: this.state.resourceSlot,
      productIndex: EditedProduct.index,
      extraFields: extraFields,
      order_item_id: EditedProduct.order_item_id,
      forcedPrice: EditedProduct.forcedPrice,
      discount: EditedProduct.discount,
      discountType: EditedProduct.discountType,
      usedComponents: usedComponents,
    });

    let deltaQuantity = quantity - EditedProduct.quantity;

    if (EditedProduct.ignoreInventory && !ignoreInventory) {
      deltaQuantity = quantity;
    }

    if (!ignoreInventory) {
      this.returnInventory(originalProduct, EditedProduct, -deltaQuantity);
    }
    message.success(t("Changed successfully"));

    onClose();
  };
  checkOptions = () => {
    const selectedOptions = this.state.options;
    const options = this.props.originalProduct.options;
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      if (option.is_required) {
        const optionGroups = [...option.groups];
        if (optionGroups.length <= 0) {
          optionGroups.push(null);
        }
        for (let j = 0; j < optionGroups.length; j++) {
          const optionKey = optionGroups[j]
            ? option.id + "-" + optionGroups[j]
            : option.id;

          if (
            option.condition_parent_option &&
            !selectedOptions[optionKey] &&
            !selectedOptions[option.condition_parent_option]?.selectedOptions[
              option.condition_parent
            ]
          ) {
            continue;
          }

          if (
            !selectedOptions[optionKey] ||
            option.minimum > selectedOptions[optionKey].selected
          ) {
            return true;
          }
        }
      }
    }

    return false;
  };

  checkExtraFields = () => {
    return hasMissingRequiredExtraFields(
      this.props.originalProduct.extra_fields,
      this.state.extraFields,
    );
  };
  checkBookingSlots = () => {
    const bookingSlot = this.state.bookingSlot;

    if (!bookingSlot || bookingSlot === -1 || bookingSlot === "Out") {
      return true;
    }
    return false;
  };
  checkOutOfStock = () => {
    const { usedComponents, originalProduct } = this.props;
    const ignoreInventory = this.state.ignoreInventory;
    let type_of_product = originalProduct.type_of_product;
    const bookingSlotId = this.state.bookingSlot;
    let bookingSlot;
    if (bookingSlotId && !["OUT", -1].includes(bookingSlotId)) {
      bookingSlot = originalProduct.booking_slots.find(
        (slot) => slot.id === bookingSlotId,
      );
    }

    let inventoryReturnedFromEditedProduct =
      (!this.props.EditedProduct?.ignoreInventory &&
        bookingSlotId == this.props.EditedProduct?.booking_slot &&
        this.props.EditedProduct?.quantity) ||
      0;

    if (
      !ignoreInventory &&
      ((["stocked", "composite"].includes(type_of_product) &&
        getProductInventory(originalProduct, usedComponents) +
          inventoryReturnedFromEditedProduct <
          (originalProduct.increments || 1)) ||
        (type_of_product === "bookable" &&
          (!bookingSlot ||
            bookingSlot.inventory + inventoryReturnedFromEditedProduct <= 0)))
    ) {
      return true;
    }
    return false;
  };

  addOptionToProduct = (
    choice,
    option,
    quantity,
    quantityDifference,
    addOption,
    groupId,
  ) => {
    const gid = groupId ?? null;
    const optId = Number(option.id);
    const chId = Number(choice.id);
    const optionKey = gid ? `${optId}-${gid}` : String(optId);

    const allOptions = this.props.originalProduct?.options || [];

    const children = allOptions.filter(
      (o) =>
        Number(o.condition_parent_option) === Number(choice.option) &&
        Number(o.condition_parent) === chId,
    );

    const newOptions = { ...(this.state.options || {}) };

    const wasSelectedBefore =
      !!newOptions?.[optionKey]?.selectedOptions?.[chId];

    const newUsedComponents = { ...(this.state.usedComponents || {}) };

    if (!newOptions[optionKey]) {
      if (addOption) {
        newOptions[optionKey] = {
          name: option.name,
          ar_name: option.ar_name,
          selected: quantity,
          multiple: option.multiple,
          quantityExclusive: option.quantity_exclusive,
          conditionalOption: option.condition_parent,
          selectedOptions: {
            [chId]: {
              value: choice.value,
              ar_value: choice.ar_value,
              quantity,
              price: choice.price,
              related_product: choice.related_product,
              modifier: choice.modifier,
              maxInventory: choice.inventory,
              preparationTime: choice.preparation_time,
            },
          },
        };
      }
    } else {
      if (!addOption) {
        this.removeConditionalDescendantsInto(newOptions, chId, gid);

        if (newOptions[optionKey]?.selectedOptions) {
          delete newOptions[optionKey].selectedOptions[chId];
        }

        if (newOptions[optionKey]) {
          if (isEmpty(newOptions[optionKey].selectedOptions)) {
            delete newOptions[optionKey];
          } else {
            newOptions[optionKey].selected += quantityDifference;
          }
        }
      } else {
        if (option.maximum === 1) {
          const prevIds = Object.keys(
            newOptions[optionKey].selectedOptions || {},
          )
            .map((k) => Number(k))
            .filter((prev) => prev !== chId);
          prevIds.forEach((prevChoiceId) =>
            this.removeConditionalDescendantsInto(
              newOptions,
              prevChoiceId,
              gid,
            ),
          );

          newOptions[optionKey].selectedOptions = {
            [chId]: {
              value: choice.value,
              ar_value: choice.ar_value,
              quantity,
              price: choice.price,
              related_product: choice.related_product,
              maxInventory: choice.inventory,
              preparationTime: choice.preparation_time,
            },
          };

          newOptions[optionKey].selected = 1;
        } else {
          newOptions[optionKey].selected =
            (newOptions[optionKey].selected || 0) + quantityDifference;

          newOptions[optionKey].selectedOptions = {
            ...(newOptions[optionKey].selectedOptions || {}),
            [chId]: {
              value: choice.value,
              ar_value: choice.ar_value,
              quantity,
              price: choice.price,
              related_product: choice.related_product,
              maxInventory: choice.inventory,
              preparationTime: choice.preparation_time,
            },
          };
        }
      }
    }

    if (choice.inventory !== null && choice.related_product) {
      if (choice.related_product.type_of_product === "composite") {
        Object.entries(choice.related_product.components).forEach(
          ([productId, product]) => {
            let componentProductId = productId;
            if (option.quantity_exclusive) componentProductId += "Q";
            newUsedComponents[componentProductId] =
              (newUsedComponents[componentProductId] || 0) +
              quantityDifference * product.required_amount;
          },
        );
      } else {
        let componentProductId = choice.related_product.id;
        if (option.quantity_exclusive) componentProductId += "Q";
        newUsedComponents[componentProductId] =
          (newUsedComponents[componentProductId] || 0) + quantityDifference;
      }
    }

    this.setState(
      { options: newOptions, usedComponents: newUsedComponents },
      () => {
        if (addOption && children.length && !wasSelectedBefore) {
          if (this.state.conditionalStack) {
            this.setState((prev) => ({
              conditionalStack: [
                ...prev.conditionalStack,
                {
                  parent: {
                    optionId: Number(choice.option),
                    choiceId: chId,
                    choiceName: choice.value,
                    groupId: gid,
                  },
                  options: children,
                },
              ],
            }));
          } else {
            this.setState({
              conditionalModal: {
                visible: true,
                parent: {
                  optionId: Number(choice.option),
                  choiceId: chId,
                  choiceName: choice.value,
                  groupId: gid,
                },
                options: children,
              },
            });
          }
        }
      },
    );
  };

  addExtraFieldsToProduct = (extraField, value, key) => {
    let newExtraFields = this.state.extraFields;

    if (!newExtraFields[key]) {
      newExtraFields[key] = {
        value: value,
        type: extraField.type,
        name: extraField.name,
        ar_name: extraField.ar_name,
        price: extraField.price,
        quantityExclusive: extraField.quantity_exclusive,
      };
    } else {
      newExtraFields[key].value = value;
      if (value == "" || value == null) {
        delete newExtraFields[key];
      }
    }

    this.setState({ extraFields: newExtraFields });
  };
  SetBookingSlot = (slot) => {
    this.setState({ bookingSlot: slot, quantity: 1 });
  };

  addButttonDisabled = (outOfStock) => {
    const { originalProduct } = this.props;

    if (this.state.uploadLoading) return true;
    if (!originalProduct.did_load) return true;

    if (outOfStock) {
      return true;
    }
    if (originalProduct.options.length && this.checkOptions()) {
      return true;
    }

    if (originalProduct.extra_fields.length && this.checkExtraFields()) {
      return true;
    }
    if (
      originalProduct.type_of_product === "bookable" &&
      this.checkBookingSlots()
    ) {
      return true;
    }

    if (
      originalProduct.type_of_product === "service" &&
      (!this.state.has_resources || !this.state.has_resource_slots)
    ) {
      return true;
    }

    if (this.state.quantity <= 0) return true;

    return false;
  };
  handleInputNumberChange = (
    newQuantity,
    originalProduct,
    originalQuantity,
  ) => {
    const { settings } = this.props;
    const maxQuantity = Math.min(
      this.getMaxInventory(originalProduct),
      this.getMaximumProductInventoryFromModifiers(),
    );

    if (!newQuantity || !maxQuantity) {
      this.setState({ quantity: originalProduct.increments });
      return;
    }
    if (newQuantity > maxQuantity) {
      newQuantity = maxQuantity;
    }
    if (isNaN(newQuantity) || newQuantity <= 0) {
      newQuantity = originalQuantity;
    }

    if (!settings.allow_any_quantity_pos) {
      newQuantity =
        Math.floor(newQuantity / originalProduct.increments) *
        originalProduct.increments;
    }

    this.setNewQuantity(newQuantity);
  };
  setIgnoreInventory = (checked) => {
    const { quantity } = this.state;
    const { originalProduct } = this.props;

    if (!checked && quantity > originalProduct.increments) {
      let maxQuantity = Math.min(
        this.getMaxInventory(originalProduct, true),
        this.getMaximumProductInventoryFromModifiers(),
      );

      if (maxQuantity < quantity) {
        this.setNewQuantity(
          Math.floor(maxQuantity / originalProduct.increments) *
            originalProduct.increments,
        );
      }
    }
    this.setState({ ignoreInventory: checked });
  };
  getTotalPrice = (sum, quantity, options, extras, getTotal = false) => {
    const { EditedProduct } = this.props;
    if (quantity <= 0) return 0;
    if (getTotal && EditedProduct?.forcedPrice != null) {
      return EditedProduct.forcedPrice * quantity;
    }
    let selected_option = {};
    let optionSum = 0;
    sum = sum * quantity;
    let quantityExcludedOptionsTotal = 0;

    for (let key of Object.keys(options)) {
      optionSum = 0;
      selected_option = options[key].selectedOptions;

      if (isEmpty(selected_option)) delete options[key];
      else {
        for (let selected_key of Object.keys(selected_option)) {
          optionSum +=
            selected_option[selected_key].quantity *
            selected_option[selected_key].price;
        }
        if (options[key].quantityExclusive) {
          quantityExcludedOptionsTotal = preciseNumber(
            quantityExcludedOptionsTotal + optionSum,
          );
        } else {
          sum += optionSum * quantity;
        }
      }
    }

    Object.values(extras).forEach((extra) => {
      if (extra.quantityExclusive) {
        quantityExcludedOptionsTotal = preciseNumber(
          quantityExcludedOptionsTotal + extra.price,
        );
      } else {
        sum = preciseNumber(sum + extra.price * quantity);
      }
    });

    if (getTotal) {
      return preciseNumber(sum + quantityExcludedOptionsTotal);
    }

    return {
      total_price: sum,
      quantityExcludedOptionsTotal: quantityExcludedOptionsTotal,
    };
  };

  handleConditionalClose = () => {
    const current = this.getCurrentConditional();
    if (!current) return;
    const valid = this.areConditionalOptionsValid(current);
    if (!valid) this.unselectConditionalParent(current);
    this.setState((prev) => ({
      conditionalStack: prev.conditionalStack.slice(0, -1),
    }));
  };

  unselectConditionalParent = (layer) => {
    const current = layer || this.getCurrentConditional();
    const parent = current?.parent;
    if (!parent) return;

    const allOptions = this.props.originalProduct?.options || [];
    const parentOption = allOptions.find((o) => o.id === parent.optionId);
    if (!parentOption) return;

    const parentChoice = parentOption.choices.find(
      (c) => c.id === parent.choiceId,
    );
    if (!parentChoice) return;

    const selectedOptionsState = this.state.options || {};
    const optionKey = parent.groupId
      ? `${parent.optionId}-${parent.groupId}`
      : String(parent.optionId);
    const prevQty =
      selectedOptionsState?.[optionKey]?.selectedOptions?.[parent.choiceId]
        ?.quantity ?? 0;

    const isRadio = parentOption.maximum === 1;
    const qtyToRemove = isRadio ? 1 : prevQty;

    if (qtyToRemove > 0) {
      this.addOptionToProduct(
        parentChoice,
        parentOption,
        0,
        -qtyToRemove,
        false,
        parent.groupId || null,
      );
    }
  };

  removeConditionalDescendantsInto = (opts, choiceId, groupId = null) => {
    const all = this.props.originalProduct?.options || [];
    const queue = [choiceId];
    const optionIdsToRemove = new Set();

    while (queue.length) {
      const cid = queue.shift();
      for (const opt of all) {
        if (opt.condition_parent === cid) {
          optionIdsToRemove.add(opt.id);

          if (opt.choices?.length) {
            opt.choices.forEach((ch) => queue.push(ch.id));
          }
        }
      }
    }

    if (!optionIdsToRemove.size) return;

    optionIdsToRemove.forEach((optId) => {
      const key = groupId ? `${optId}-${groupId}` : String(optId);
      if (key in opts) delete opts[key];
    });
  };

  areConditionalOptionsValid = (layer) => {
    const { options: selectedOptionsState } = this.state;
    const { options: children, parent } =
      layer || this.getCurrentConditional() || {};
    const groupId = parent?.groupId || null;

    if (!children.length) return true;

    for (const opt of children) {
      if (opt.condition_parent && opt.condition_parent_option) {
        const parentKey = groupId
          ? `${opt.condition_parent_option}-${groupId}`
          : opt.condition_parent_option;
        const parentSelected =
          !!selectedOptionsState[parentKey]?.selectedOptions?.[
            opt.condition_parent
          ];
        if (!parentSelected) continue;
      }
      const optionKey = groupId ? `${opt.id}-${groupId}` : opt.id;
      const selectedCount = selectedOptionsState[optionKey]?.selected || 0;
      const min = opt.minimum ?? 0;
      const max =
        opt.maximum == null
          ? Infinity
          : +opt.maximum === 0
            ? Infinity
            : +opt.maximum;

      if ((opt.is_required && selectedCount < min) || selectedCount > max)
        return false;
    }
    return true;
  };

  unmetConditionalRequirements = (layer) => {
    const { options: selectedOptionsState } = this.state;
    const { options: children, parent } =
      layer || this.getCurrentConditional() || {};
    const groupId = parent?.groupId || null;
    const unmet = [];

    for (const opt of children) {
      if (opt.condition_parent && opt.condition_parent_option) {
        const parentKey = groupId
          ? `${opt.condition_parent_option}-${groupId}`
          : opt.condition_parent_option;
        const parentSelected =
          !!selectedOptionsState[parentKey]?.selectedOptions?.[
            opt.condition_parent
          ];
        if (!parentSelected) continue;
      }

      if (opt.is_required) {
        const optionKey = groupId ? `${opt.id}-${groupId}` : opt.id;
        const selectedCount = selectedOptionsState[optionKey]?.selected || 0;
        const min = opt.minimum || 0;
        if (selectedCount < min) {
          unmet.push({
            id: opt.id,
            name: opt.name,
            ar_name: opt.ar_name,
            needed: min - selectedCount,
          });
        }
      }
    }
    return unmet;
  };

  openConditionalModal = (choice, groupId) => {
    const allOptions = this.props.originalProduct?.options || [];
    const children = allOptions.filter(
      (opt) =>
        opt.condition_parent_option === choice.option &&
        opt.condition_parent === choice.id,
    );
    if (!children.length) return;
    this.setState((prev) => ({
      conditionalStack: [
        ...prev.conditionalStack,
        {
          parent: {
            optionId: choice.option,
            choiceId: choice.id,
            choiceName: choice.value,
            groupId: groupId || null,
          },
          options: children,
        },
      ],
    }));
  };
  render() {
    const {
      t,
      config,
      originalProduct,
      visible,
      product,
      settings,
      EditedProduct,
      promotions,
      categories,
    } = this.props;
    const {
      quantity,
      options,
      ignoreInventory,
      extraFields,
      specialRemarks,
      bookingSlot,
      descriptionModalVisible,
      usedComponents,
    } = this.state;
    const outOfStock = this.checkOutOfStock();

    let currency = settings.currency_english;
    let totalPriceFloat = "float-right";
    if (config.language === "arabic") {
      currency = settings.currency_local;
      totalPriceFloat = "float-left";
    }

    let promoQuantity = 0;
    let promoItems = [];
    if (promotions.products.length || promotions.category_free?.length) {
      promoItems = promotions.products
        .filter(
          (p) =>
            p.quantity > 0 &&
            ((p.has_variants && p.product_id === product.parent) ||
              (!p.has_variants && p.product_id === product.id)) &&
            (!EditedProduct || p.id === EditedProduct?.discount),
        )
        .concat(
          promotions.category_free.filter(
            (cd) =>
              cd.quantity > 0 &&
              isApplicableCategeoryPromo(
                cd.categories.map((c) => c.id),
                product,
                categories,
              ) &&
              isNotExcludedProuduct(product, [], []),
          ),
        );

      if (promoItems.length) {
        let newpromoQuantity = 0;
        promoItems.forEach((item) => {
          newpromoQuantity += item.quantity;
        });
        promoQuantity = newpromoQuantity;
      }
    }
    const price = this.getTotalPrice(
      this.getProductUnitPrice(originalProduct, bookingSlot),
      quantity - promoQuantity,
      options,
      extraFields,
      true,
    );
    return (
      <Modal
        destroyOnClose
        style={{ top: 20 }}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {EditedProduct && t("Editing ")}
            {GetEnglishOrArabic(product.name, product.ar_name, config.language)}
            {originalProduct.did_load &&
              (product.description || product.short_description) && (
                <Button
                  type={"link"}
                  onClick={() =>
                    this.setState({ descriptionModalVisible: true })
                  }
                >
                  {t("More Details")}
                  <QuestionCircleOutlined
                    style={{ position: "relative", top: -2 }}
                  />
                </Button>
              )}
          </div>
        }
        open={visible}
        onCancel={this.props.onClose}
        footer={[
          <Button
            block
            className="posActionButton"
            disabled={this.addButttonDisabled(outOfStock)}
            key="add to cart"
            type="primary"
            onClick={() =>
              EditedProduct
                ? this.EditProduct()
                : this.addProductToCart(promoItems)
            }
          >
            {this.state.uploadLoading ? (
              <div className="text-center">
                <Spin indicator={antIcon} />
              </div>
            ) : (
              <Row justify="space-between">
                <Col span={8}></Col>
                <Col span={8}>
                  {outOfStock
                    ? t("Out of Stock")
                    : EditedProduct
                      ? t("Edit")
                      : t("Add to Cart")}
                </Col>
                <Col span={8}>
                  {!outOfStock && (
                    <span
                      className={totalPriceFloat}
                    >{`${price} ${currency}`}</span>
                  )}
                </Col>
              </Row>
            )}
          </Button>,
        ]}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
      >
        {originalProduct.did_load ? (
          <>
            {descriptionModalVisible && (
              <ProductDescription
                product={originalProduct}
                visible={descriptionModalVisible}
                onClose={() => {
                  this.setState({
                    descriptionModalVisible: false,
                  });
                }}
              />
            )}

            {originalProduct.booking_slots.length > 0 &&
              originalProduct.type_of_product == "bookable" && (
                <ProductBookables
                  bookingSlot={bookingSlot}
                  bookingSlots={originalProduct.booking_slots}
                  SetBookingSlot={this.SetBookingSlot}
                  ignoreInventory={ignoreInventory}
                />
              )}
            {product.type_of_product == "service" && (
              <ProductResources
                current_product={product}
                setResource={(rid) =>
                  this.setState({
                    resource: rid,
                    resourceError: false,
                    resourceSlot: null,
                  })
                }
                setResourceSlot={(slotStr) =>
                  this.setState({ resourceSlot: slotStr, resourceError: false })
                }
                resourceError={this.state.resourceError}
                setHasResources={(val) => this.setState({ has_resources: val })}
                setHasResourceSlots={(val) =>
                  this.setState({ has_resource_slots: val })
                }
              />
            )}

            {product.type_of_product !== "service" && (
              <div className=" mt-5 mb-4 disable-select text-center">
                <p style={{ fontSize: 20 }}>{t("Quantity")}</p>
                <Row
                  className="mt-2"
                  justify="center"
                  style={{ alignItems: "baseline" }}
                >
                  <Col span={2}>
                    {" "}
                    <MinusCircleOutlined
                      style={{ fontSize: "25px", color: "#0099CC" }}
                      onClick={() => {
                        let newQuantity = quantity;
                        let increments = originalProduct["increments"];

                        newQuantity = parseFloat(
                          (newQuantity - increments).toPrecision(6),
                        );
                        if (newQuantity <= 0) newQuantity = increments;

                        this.setNewQuantity(newQuantity);
                      }}
                    />
                  </Col>
                  <Col span={8}>
                    <InputNumber
                      className="product-input-number border"
                      value={quantity}
                      style={{
                        fontSize: "25px",
                        textAlign: "center",
                        border: "none",
                      }}
                      onChange={(newQuantity) => {
                        if (EditedProduct?.discount) {
                          newQuantity = Math.min(
                            newQuantity,
                            promoQuantity + EditedProduct?.quantity,
                          );
                        }
                        this.handleInputNumberChange(
                          newQuantity,
                          originalProduct,
                          quantity,
                        );
                      }}
                    />
                  </Col>
                  <Col span={2}>
                    <PlusCircleOutlined
                      style={{ fontSize: "25px", color: "#0099CC" }}
                      onClick={() => {
                        let newQuantity = quantity;
                        let increments = originalProduct["increments"];

                        newQuantity = parseFloat(
                          (newQuantity + increments).toPrecision(6),
                        );

                        if (EditedProduct?.discount) {
                          newQuantity = Math.min(
                            newQuantity,
                            promoQuantity + EditedProduct?.quantity,
                          );
                        }

                        if (
                          ignoreInventory ||
                          (this.hasEnoughInventory(
                            newQuantity,
                            originalProduct,
                          ) &&
                            newQuantity <=
                              this.getMaximumProductInventoryFromModifiers())
                        ) {
                          this.setNewQuantity(newQuantity);
                        }
                      }}
                    />
                  </Col>
                </Row>
                {["stocked", "bookable", "composite"].includes(
                  originalProduct.type_of_product,
                ) &&
                  !settings.enable_advanced_inventory_system && (
                    <div className="mt-3 mb-4 ">
                      <p>
                        <Checkbox
                          checked={ignoreInventory}
                          className="mx-3"
                          onChange={(e) => {
                            this.setIgnoreInventory(e.target.checked);
                          }}
                        />
                        {`${t("Override Stock")}`}{" "}
                      </p>
                    </div>
                  )}
              </div>
            )}

            {originalProduct.options.length > 0 && (
              <ProductOptions
                options={originalProduct.options}
                addOptionToProduct={this.addOptionToProduct}
                selectedOptions={{ ...options }}
                productUsedComponents={usedComponents}
                productQuantity={quantity}
                editedProduct={this.props.EditedProduct}
                optionsGroups={originalProduct.options_groups}
                onOpenConditionalModal={this.openConditionalModal}
                allOptions={originalProduct.options}
              />
            )}
            {originalProduct.extra_fields?.length > 0 && (
              <ProductExtraFields
                extraFields={originalProduct.extra_fields}
                selectedExtraFields={{ ...extraFields }}
                addExtraFieldsToProduct={this.addExtraFieldsToProduct}
                optionsGroups={originalProduct.extra_fields_options_groups}
                setUploadLoading={(v) => this.setState({ uploadLoading: v })}
              />
            )}
            <div className="mt-3 mb-4">
              <p className="text-center" style={{ fontSize: 20 }}>
                {t("Special Remarks")}
              </p>
              <Input
                placeholder={t("Special Remarks")}
                value={specialRemarks}
                onChange={(e) =>
                  this.setState({ specialRemarks: e.target.value.trimLeft() })
                }
              />
            </div>
          </>
        ) : (
          <div className="my-4 text-center">
            <Spin indicator={antIcon} />
          </div>
        )}

        {this.state.conditionalStack.length > 0 &&
          (() => {
            const layer = this.getCurrentConditional();
            const parentGroupId = layer.parent?.groupId || null;

            const allGroups = this.props.originalProduct.options_groups || [];
            const parentGroup =
              parentGroupId != null
                ? allGroups.find((g) => Number(g.id) === Number(parentGroupId))
                : undefined;

            return (
              <Modal
                destroyOnClose
                style={{ top: 10 }}
                maskClosable={true}
                closable={true}
                keyboard={true}
                onCancel={this.handleConditionalClose}
                open
                footer={[
                  <Button
                    key="done"
                    type="primary"
                    disabled={!this.areConditionalOptionsValid(layer)}
                    onClick={this.handleConditionalClose}
                  >
                    {t("Done")}
                  </Button>,
                ]}
                title={
                  <div className="ant-modal-title">
                    {t("More Options")}
                    {layer.parent?.choiceName
                      ? ` — ${GetEnglishOrArabic(
                          layer.parent.choiceName,
                          layer.parent.choiceName,
                          this.props.config.language,
                        )}`
                      : ""}
                  </div>
                }
              >
                {layer.options.map((child, idx) => (
                  <OptionGroup
                    key={`conditional-${idx}-${child.id}-${
                      parentGroupId ?? "nog"
                    }`}
                    option={child}
                    productUsedComponents={this.state.usedComponents}
                    addOptionToProduct={(ch, op, qty, qdiff, add, gId) =>
                      this.addOptionToProduct(
                        ch,
                        op,
                        qty,
                        qdiff,
                        add,
                        parentGroupId ?? gId,
                      )
                    }
                    selectedOverall={
                      parentGroupId
                        ? (this.state.options[`${child.id}-${parentGroupId}`]
                            ?.selected ?? 0)
                        : (this.state.options[child.id]?.selected ?? 0)
                    }
                    selectedOptions={
                      parentGroupId
                        ? (this.state.options[`${child.id}-${parentGroupId}`]
                            ?.selectedOptions ?? {})
                        : (this.state.options[child.id]?.selectedOptions ?? {})
                    }
                    productQuantity={this.state.quantity}
                    editedProduct={this.props.EditedProduct}
                    group={parentGroup}
                    allOptions={this.props.originalProduct.options}
                    onOpenConditionalModal={this.openConditionalModal}
                  />
                ))}

                {(() => {
                  const unmet = this.unmetConditionalRequirements(layer);
                  if (!unmet.length)
                    return (
                      <div
                        style={{ marginTop: 8, fontSize: 12 }}
                        className="text-muted"
                      >
                        <br />
                      </div>
                    );
                  const names = unmet
                    .map((u) =>
                      GetEnglishOrArabic(
                        u.name,
                        u.ar_name,
                        this.props.config.language,
                      ),
                    )
                    .join(", ");
                  return (
                    <div
                      style={{ marginTop: 8, fontSize: 12 }}
                      className="text-muted"
                    >
                      {t
                        ? t("Please complete required selections:")
                        : "Please complete required selections:"}{" "}
                      {names}
                    </div>
                  );
                })()}
              </Modal>
            );
          })()}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
    usedComponents: state.pos.usedComponents,
    promotions: state.pos.discounts,
    categories: state.pos.branchProducts?.categories || [],
    pos: state.pos,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editProductFromCart: (params) => dispatch(editProductFromCart(params)),
    addProductToCart: (params) => dispatch(addProductToCart(params)),
    updateProduct: (product) => dispatch(updateProduct(product)),
    updatePOSBranchProduct: (product) =>
      dispatch(updatePOSBranchProduct(product)),
    updateUsedComponents: (usedComponents) =>
      dispatch(updateUsedComponents(usedComponents)),
    editProductFromCart: (params) => dispatch(editProductFromCart(params)),
    setDeliveryChargePOS: (params) => dispatch(setDeliveryChargePOS(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(ProductModal));
